"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var Rails_1 = require("../../utils/Rails");
var utils_1 = require("../../utils/utils");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    content: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_CONTENT,
        onSuccess: api_1.createApiOnSuccessReducer(function (_, action) {
            var _a;
            if (utils_1.isNotNilOrEmpty(action.payload.experience.section)) {
                var rails = action.payload.experience.section.home.groups;
                if (action.payload.experience.section.home.group) {
                    rails = rails.map(function (rail) {
                        if (rail.id === action.payload.experience.section.home.group.id) {
                            return action.payload.experience.section.home.group;
                        }
                        return rail;
                    });
                }
                return {
                    heroSet: action.payload.experience.section.home.heroSet,
                    rails: rails || [],
                    sectionId: action.payload.experience.section.id,
                };
            }
            return {
                sectionId: (_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.sectionId,
            };
        }),
        onFailure: function (draftState, action) {
            var _a;
            draftState.error = action.payload;
            draftState.data = { sectionId: (_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.sectionId };
        },
    })), Rails_1.createRailReducer(constants_1.FETCH_RAIL)), api_1.createApiInitialState({
        heroSet: undefined,
        rails: [],
        sectionId: null,
    })),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map